<div class="page-header">
  <div class="header-start">
    <h3 class="title">List Of Roles</h3>
  </div>
  <div class="header-end">
    <div class="form-ng-select">

      <ng-select class="ng-select-toolbar" *ngIf="!isCustomer" name="customerList" [items]="customerListData"
        placeholder="Search Customers" bindLabel="customerName" [closeOnSelect]="true" (change)="onCustomerSelect($event)"
        (clear)="clearCustomerOptions()" [(ngModel)]="customerSelected" (keydown)="onKeyDown($event)">
      </ng-select>
    </div>


    <button permissions resourceName="ROLE" permission="EDIT" class="btn btn-primary " (click)="openAddProfileModal()"
      mat-raised-button color="primary">
      <i class="fas fa-plus mr-2"></i> Add Role
    </button>
  </div>
</div>


<div class="position-relative mb-3" *ngIf="!loading">
  <spinner [id]="'role-list-data'" [show]='loading'></spinner>
  <lib-data-table tableType="dataTable" tableId=rolelist [tableConfig]="tableConfig" [data]="tableData"
    (optionsClick)="handleOptionClick($event)" [clickableDataTypes]="dataTypes" [customTemplates]="{'status': status}">
  </lib-data-table>
  <ng-template #status let-rowData="rowData" let-index="index">
    <td (click)="handleRowClick(rowData,index)">
      <span class="font-weight-bold"
        [ngClass]="rowData[index]?.values[0] === 'Active' ? 'text-success':'text-danger'">{{rowData[index]?.values[0]}}</span>
    </td>
  </ng-template>
</div>